const integrations = [
  { name: "Zapier", description: "Workflow automation", slug: "zapier" },
  { name: "n8n", description: "Self-hosted automation", slug: "n8n" },
  { name: "Twilio", description: "SMS & voice", slug: "twilio" },
  { name: "SendGrid", description: "Email delivery", slug: "sendgrid" },
  { name: "Xero", description: "Accounting & finance", slug: "xero" },
  { name: "Akixi", description: "Call analytics", slug: "akixi" },
  { name: "Microsoft Graph", description: "M365 data & auth", slug: "microsoft" },
  { name: "OpenAI APIs", description: "LLM + embeddings", slug: "openai" }
];

export default integrations;
